module.exports = __webpack_public_path__ + "static/media/target.1a81d5b3.png";